/**
 * Share Button functionality
 *
 * Handles the share button dropdown toggle and close behavior.
 */

export function initShareButton() {
    const containers = document.querySelectorAll('.share-button-container');

    containers.forEach((container) => {
        const trigger = container.querySelector('.share-button-trigger');
        const dropdown = container.querySelector('.share-dropdown');
        const closeBtn = container.querySelector('.share-dropdown-close');

        if (!trigger || !dropdown) return;

        // Toggle dropdown on trigger click
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = !dropdown.hidden;

            if (isOpen) {
                closeDropdown(trigger, dropdown);
            } else {
                openDropdown(trigger, dropdown);
            }
        });

        // Close dropdown on close button click
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                closeDropdown(trigger, dropdown);
            });
        }

        // Close dropdown on click outside
        document.addEventListener('click', (e) => {
            if (!container.contains(e.target) && !dropdown.hidden) {
                closeDropdown(trigger, dropdown);
            }
        });

        // Close dropdown on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !dropdown.hidden) {
                closeDropdown(trigger, dropdown);
                trigger.focus();
            }
        });
    });
}

function openDropdown(trigger, dropdown) {
    dropdown.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
}

function closeDropdown(trigger, dropdown) {
    dropdown.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
}
